import React, {useRef,useEffect} from 'react';
import { ClockCircleOutlined } from '@ant-design/icons';
import './countdown.less';
import { fillZero } from 'utils/utility-functions';


const Countdown = (props) => {
  const countDownRef = useRef(null);
  function startOtpCounter() {
    const countDownDate = new Date().getTime() + (120 * 1000);
    const countdownObj =countDownRef.current;
    let x = setInterval(() => {
        let now = new Date().getTime();
        let distance = countDownDate - now;
        let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((distance % (1000 * 60)) / 1000);
        countdownObj.innerHTML = minutes + ":" + fillZero(seconds) + "";
        if (distance < 0) {
            clearInterval(x);
            countdownObj.innerHTML = "Şifre Zaman Aşımına Uğradı";
            changeCounter(false);
        }
    }, 1000);
  }

  function changeCounter(operation) {
    props.changedCounter(operation);
    if (operation) {
        startOtpCounter();
    }
  }

  useEffect(() => {
    if (props.startCounter)
    {
      startOtpCounter();
    }
  }, [props.startCounter]);


  // useEffect(() => {
  //   startOtpCounter();
  // }, []);
  return (
    <div
      className="countdown background-color-neutral-1"
      style={{ borderRadius: 40 }}
    >
      <ClockCircleOutlined />
      <span ref={countDownRef}>1:59</span>
    </div>
  );
};

export default Countdown;
